import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_DISPATCH_ORDERS_LIST = {
  'dispatchOrdersList': [],
  'loading': false,
};

export const dispatchOrders = (state, action) => {
  return createReducer(INITIAL_STATE_DISPATCH_ORDERS_LIST, {
    [ActionTypes.FETCHING_DISPATCH_ORDERS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
      'dispatchOrdersList': [],
    }),
    [ActionTypes.FETCHED_DISPATCH_ORDERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'dispatchOrdersList': [],
    }),
    [ActionTypes.FETCHED_DISPATCH_ORDERS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'dispatchOrdersList': action.response.data,
    }),
  })(state, action);
};
